import React from 'react'

import startCase from 'lodash/startCase'

import { ButtonRow, Button } from '../buttons'

export default ({
  history,
  issueDescription,
  updatedBy
}) => (
  <div className='history-item'>
    <div className='history-details'>
      {history.imageUrl &&
        <ButtonRow>
          <Button
            small
            externalUrl={history.imageUrl}
            >
              View Image
            </Button>
          </ButtonRow>}

      <p className='timestamp'>
        {history.createdAt.format('MMMM D, YYYY [at] h:mm A')} by {updatedBy.name}
      </p>
    </div>

    <div>
      <p>Status: {startCase(history.status)}</p>
      <p>Description: {issueDescription.name || '—'}</p>
      <p>Notes: {history.notes || '—'}</p>
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/issue-histories/issue-history-card.js